import React from 'react';
import {DiffHeader} from './diff/DiffHeader';
import {DiffRecords} from './diff/DiffRecords';
import styled from 'styled-components';
import {SchemaWithoutScreen} from '../types/Schema';
import {DiffMap} from './diff/DiffMap';
import {DiffField} from './diff/DiffField';
import {border} from './diff/styles';
import {FieldOutputProps} from '../field/DetailsFieldValue';
import {ResourceDetails} from '../types/ResourceDetails';

type Props = FieldOutputProps & {
  schema: SchemaWithoutScreen;
  fields: DiffField[];
  diff: DiffMap;
  oldData: ResourceDetails;
  newData: ResourceDetails;
};

export const ResourceDiffWidget: React.FC<Props> = (props) => {
  return (
    <Container>
      <DiffHeader {...props} />
      <DiffRecords {...props} />
    </Container>
  );
};

const Container = styled.table`
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  ${border}
`;
